import Vue from 'vue'
import Router from 'vue-router'

const Index = resolve => require(['/page/index'], resolve)
const Authorize = resolve => require(['/page/authorize'], resolve)
const Huanyingci = resolve => require(['/page/huanyingci'], resolve)
const Huiyixinxi = resolve => require(['/page/huiyixinxi'], resolve)
const Kaifazhong = resolve => require(['/page/kaifazhong'], resolve)
const Kaifazhong1 = resolve => require(['/page/kaifazhong1'], resolve)
const Lianxiwomen = resolve => require(['/page/lianxiwomen'], resolve)
const Xianshangzhanshi = resolve => require(['/page/xianshangzhanshi'], resolve)
const Xuefen = resolve => require(['/page/xuefen'], resolve)
const Huiyiricheng1 = resolve => require(['/page/huiyiricheng1'], resolve)
const Huiyizhibo = resolve => require(['/page/huiyizhibo'], resolve)
const Huiyizhuce = resolve => require(['/page/huiyizhuce'], resolve)
const Video = resolve => require(['/page/video'], resolve)
const Gerenzhongxin = resolve => require(['/page/gerenzhongxin'], resolve)

// const Index1 = resolve => require(['/page/index1'], resolve)
// const Index2 = resolve => require(['/page/index2'], resolve)
// const Zhuanjialist = resolve => require(['/page/zhuanjialist'], resolve)
// const Huiyiricheng = resolve => require(['/page/huiyiricheng'], resolve)
// const Zaixianzhantai = resolve => require(['/page/zaixianzhantai'], resolve)
// const Zhixie = resolve => require(['/page/zhixie'], resolve)
// const Zhuanjiaditail = resolve => require(['/page/zhuanjiadetail'], resolve)
// const Huiyizhuce = resolve => require(['/page/huiyizhuce'], resolve)
// const Gerenzhongxin = resolve => require(['/page/gerenzhongxin'], resolve)
// const Canhuizhuce = resolve => require(['/page/canhuizhuce'], resolve)
// const Canhuizhuce2 = resolve => require(['/page/canhuizhuce2'], resolve)
// const Zhuce = resolve => require(['/page/zhuce'], resolve)
// const Login = resolve => require(['/page/login'], resolve)
// const Yaoqing = resolve => require(['/page/yaoqing'], resolve)
// const Gerenziliao = resolve => require(['/page/gerenziliao'], resolve)
// const detail1 = resolve => require(['/page/detail1'], resolve)


Vue.use(Router)
export default new Router({
  mode: 'history',
  routes: [
    {path: '/index', name: 'index', component: Index},
    {path: '/authorize', name: 'authorize', component: Authorize},
    {path: '/huanyingci', name: 'huanyingci', component: Huanyingci},
    {path: '/huiyixinxi', name: 'huiyixinxi', component: Huiyixinxi},
    {path: '/kaifazhong', name: 'kaifazhong', component: Kaifazhong},
    {path: '/kaifazhong1', name: 'kaifazhong1', component: Kaifazhong1},
    {path: '/lianxiwomen', name: 'lianxiwomen', component: Lianxiwomen},
    {path: '/xianshangzhanshi', name: 'xianshangzhanshi', component: Xianshangzhanshi},
    {path: '/xuefen', name: 'xuefen', component: Xuefen},
    {path: '/huiyiricheng1', name: 'huiyiricheng1', component: Huiyiricheng1},
    {path: '/huiyizhibo', name: 'huiyizhibo', component: Huiyizhibo},
    {path: '/huiyizhuce', name: 'huiyizhuce', component: Huiyizhuce},
    {path: '/video', name: 'video', component: Video},
    {path: '/gerenzhongxin', name: 'gerenzhongxin', component: Gerenzhongxin},

    // {path: '/index1', name: 'index1', component: Index1},
    // {path: '/index2', name: 'index2', component: Index2},
    // {path: '/zhuanjialist', name: 'zhuanjialist', component: Zhuanjialist},
    // {path: '/huiyiricheng', name: 'huiyiricheng', component: Huiyiricheng},
    // {path: '/zaixianzhantai', name: 'zaixianzhantai', component: Zaixianzhantai},
    // {path: '/zhixie', name: 'zhixie', component: Zhixie},
    // {path: '/zhuanjiadetail', name: 'zhuanjiadetail', component: Zhuanjiaditail},
    // {path: '/huiyizhuce', name: 'huiyizhuce', component: Huiyizhuce},

    // {path: '/canhuizhuce', name: 'canhuizhuce', component: Canhuizhuce},
    // {path: '/canhuizhuce2', name: 'canhuizhuce2', component: Canhuizhuce2},
    // {path: '/zhuce', name: 'zhuce', component: Zhuce},
    // {path: '/login', name: 'login', component: Login},
    // {path: '/gerenziliao', name: 'gerenziliao', component: Gerenziliao},
    // {path: '/yaoqing', name: 'yaoqing', component: Yaoqing},
    // {path: '/authorize', name: 'authorize', component: Authorize},
    // {path: '/detail1', name: 'detail1', component: detail1}
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js